import { useEffect, useState } from "react";
import useDebouncedCallback from "./useDebouncedCallback";

/** Trailing-edge value debounce. Initial values are immediate; zero disables the delay. */
export default function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(() => value);
  const delay = Number.isFinite(delayMs) ? Math.max(0, delayMs) : 250;
  const updateValue = useDebouncedCallback((next: T) => setDebouncedValue(() => next), delay);

  useEffect(() => {
    updateValue(value);
  }, [value, updateValue]);

  return delay === 0 ? value : debouncedValue;
}
